module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-default margin-bottom-0px"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Campaign List")]), _vm._v(" "), _c('div', {
    staticClass: "filter-container pull-right"
  }, [_c('div', {
    staticClass: "margin-lr-20px",
    staticStyle: {
      "flex": "0.1"
    }
  }, [_c('label', {
    attrs: {
      "for": "date-from"
    }
  }, [_vm._v("Campaign Start Date")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDt),
      expression: "fromDt"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "id": "date-from",
      "placeholder": "From"
    },
    domProps: {
      "value": (_vm.fromDt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDt = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "basic-addon2"
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.clearDate('fromDt')
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "margin-lr-20px",
    staticStyle: {
      "flex": "0.1"
    }
  }, [_c('label', {
    attrs: {
      "for": "date-to"
    }
  }, [_vm._v("Campaign End Date")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toDt),
      expression: "toDt"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "id": "date-to",
      "placeholder": "To"
    },
    domProps: {
      "value": (_vm.toDt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toDt = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "basic-addon2"
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.clearDate('toDt')
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "margin-lr-20px",
    staticStyle: {
      "flex": "0.2"
    }
  }, [_c('label', {
    attrs: {
      "for": "countries"
    }
  }, [_vm._v("Countries")]), _vm._v(" "), _c('treeselect', {
    staticStyle: {
      "min-width": "200px"
    },
    attrs: {
      "placeholder": "--Choose countries--",
      "multiple": true,
      "options": _vm.countryOptions
    },
    model: {
      value: (_vm.countries),
      callback: function($$v) {
        _vm.countries = $$v
      },
      expression: "countries"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "search-opportunity",
    staticStyle: {
      "flex": "0.2"
    }
  }, [_c('label', {
    attrs: {
      "for": "search"
    }
  }, [_vm._v("Campaign")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "reset-input",
      rawName: "v-reset-input"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.searchOpportunity),
      expression: "searchOpportunity"
    }],
    staticClass: "form-control searchBox",
    attrs: {
      "type": "text",
      "placeholder": "Type campaign name and press 'Enter'"
    },
    domProps: {
      "value": (_vm.searchOpportunity)
    },
    on: {
      "keyup": _vm.listenEnterPress,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchOpportunity = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "margin-ltr-20px"
  }, [_c('i', {
    staticClass: "fa fa-2x fa-search",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.getAllOpportunities
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "margin-ltr-20px",
    staticStyle: {
      "flex": "0.1"
    }
  }, [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": "/opportunity"
    }
  }, [_vm._v("Create Campaign")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#is",
      "aria-controls": "is",
      "role": "tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        return _vm.setActiveTab('is')
      }
    }
  }, [_vm._v("In-Session Campaigns")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#oos",
      "aria-controls": "oos",
      "role": "tab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        return _vm.setActiveTab('oos')
      }
    }
  }, [_vm._v("Out-of-Session Campaigns")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "role": "tabpanel",
      "id": "is"
    }
  }, [(!_vm.loading && _vm.inSessionCampaignsList.length === 0) ? _c('div', {
    staticClass: "empty-report"
  }, [_c('span', [_vm._v("Sorry, no reporting data for the current search config. If loading for the first time, please add search parameters")])]) : _c('div', [_c('div', {
    staticClass: "export-container"
  }, [_c('div', [_c('label', [_vm._v(" Toggle Column Groups Visibility")]), _vm._v(" "), _c('div', {
    staticClass: "column-groups-container"
  }, _vm._l((_vm.visibleColumnsIS), function(value, key, index) {
    return _c('div', {
      key: key,
      staticClass: "column-group",
      style: (index === 0 ? 'margin-left:0px' : 'margin-left:5px')
    }, [_c('span', [_vm._v(_vm._s(key))]), _vm._v(" "), _c('label', {
      staticClass: "switch"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.visibleColumnsIS[key]),
        expression: "visibleColumnsIS[key]"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.visibleColumnsIS[key]) ? _vm._i(_vm.visibleColumnsIS[key], null) > -1 : (_vm.visibleColumnsIS[key])
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.visibleColumnsIS[key],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.visibleColumnsIS, key, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.visibleColumnsIS, key, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.visibleColumnsIS, key, $$c)
          }
        }, _vm.handleColumnVisibilityToggle]
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "slider round"
    })])])
  }), 0)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.exportCSV
    }
  }, [_vm._v("Export to CSV")])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('vue-good-table', {
    ref: "dbm-is-table",
    attrs: {
      "data-nv-no-remember": "",
      "styleClass": "vgt-table good-table condensed bordered",
      "mode": "remote",
      "columns": _vm.inSessionCampaignColumns,
      "rows": _vm.inSessionCampaignsList,
      "pagination-options": {
        enabled: true,
      },
      "group-options": {
        enabled: true,
        collapsable: true,
        row_key: 'group_id'
      },
      "sort-options": {
        enabled: false
      },
      "totalRows": _vm.inSessionCampaignsCount
    },
    on: {
      "on-page-change": _vm.onPageChangeForISDbMCampaigns,
      "on-sort-change": _vm.onSortChangeForISDbMCampaigns,
      "on-per-page-change": _vm.onPerPageChangeForISDbMCampaigns
    },
    scopedSlots: _vm._u([{
      key: "table-header-row",
      fn: function(props) {
        return [_vm._t("default", null, {
          "props": props
        }), _vm._v(" "), (props.column.field == 'start_date' || props.column.field == 'end_date') ? _c('span', [_vm._v("\n                          " + _vm._s(_vm.formatDate(props.formattedRow[props.column.field], 'd/M/Y hh:ss')) + "\n                        ")]) : (props.column.field == 'recurrence') ? _c('span', [_vm._v(_vm._s(_vm.toTitleCase(props.formattedRow[props.column.field])))]) : _c('span', [_vm._v(_vm._s(props.formattedRow[props.column.field]))])]
      }
    }, {
      key: "table-column",
      fn: function(props) {
        return [(props.column.label === 'Response %') ? _c('span', [_vm._v(" " + _vm._s(props.column.label) + "\n                        "), _c('span', {
          attrs: {
            "title": "Shows the % of users who responded with the option numbers shown in the initial message"
          }
        }, [_c('i', {
          staticClass: "fa fa-info-circle margin-10"
        })])]) : _vm._e()]
      }
    }], null, true)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_c('nv-empty-state', {
    attrs: {
      "icon": "fa-bar-chart",
      "title": "No campaigns in this period",
      "hint": "Try a different date range."
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "loadingContent"
  })], 2)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "oos"
    }
  }, [(!_vm.loading && _vm.outOfSessionCampaignsList.length === 0) ? _c('div', {
    staticClass: "empty-report"
  }, [_c('span', [_vm._v("Sorry, no reporting data for the current search config. If loading for the first time, please add search parameters")])]) : _c('div', [_c('div', {
    staticClass: "export-container"
  }, [_c('div', [_c('label', [_vm._v(" Toggle Column Groups Visibility")]), _vm._v(" "), _c('div', {
    staticClass: "column-groups-container"
  }, _vm._l((_vm.visibleColumnsOOS), function(value, key, index) {
    return _c('div', {
      key: key,
      staticClass: "column-group",
      style: (index === 0 ? 'margin-left:0px' : 'margin-left:5px')
    }, [_c('span', [_vm._v(_vm._s(key))]), _vm._v(" "), _c('label', {
      staticClass: "switch"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.visibleColumnsOOS[key]),
        expression: "visibleColumnsOOS[key]"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.visibleColumnsOOS[key]) ? _vm._i(_vm.visibleColumnsOOS[key], null) > -1 : (_vm.visibleColumnsOOS[key])
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.visibleColumnsOOS[key],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.visibleColumnsOOS, key, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.visibleColumnsOOS, key, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.visibleColumnsOOS, key, $$c)
          }
        }, _vm.handleColumnVisibilityToggle]
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "slider round"
    })])])
  }), 0)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.exportCSV
    }
  }, [_vm._v("Export to CSV")])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('vue-good-table', {
    ref: "dbm-oos-table",
    attrs: {
      "data-nv-no-remember": "",
      "mode": "remote",
      "styleClass": "vgt-table good-table condensed bordered",
      "columns": _vm.outOfSessionCampaignColumns,
      "rows": _vm.outOfSessionCampaignsList,
      "pagination-options": {
        enabled: true,
      },
      "group-options": {
        enabled: true,
        collapsable: true,
        row_key: 'group_id'
      },
      "sort-options": {
        enabled: false
      },
      "totalRows": _vm.outOfSessionCampaignsCount
    },
    on: {
      "on-page-change": _vm.onPageChangeForOOSDbMCampaigns,
      "on-sort-change": _vm.onSortChangeForOOSDbMCampaigns,
      "on-per-page-change": _vm.onPerPageChangeForOOSDbMCampaigns
    },
    scopedSlots: _vm._u([{
      key: "table-header-row",
      fn: function(props) {
        return [_vm._t("default", null, {
          "props": props
        }), _vm._v(" "), (props.column.field == 'start_date' || props.column.field == 'end_date') ? _c('span', [_vm._v("\n                          " + _vm._s(_vm.formatDate(props.formattedRow[props.column.field], 'd/M/Y hh:ss')) + "\n                        ")]) : (props.column.field == 'recurrence') ? _c('span', [_vm._v(_vm._s(_vm.toTitleCase(props.formattedRow[props.column.field])))]) : _c('span', [_vm._v(_vm._s(props.formattedRow[props.column.field]))])]
      }
    }, {
      key: "table-column",
      fn: function(props) {
        return [(props.column.label === 'Response %') ? _c('span', [_vm._v(" " + _vm._s(props.column.label) + "\n                        "), _c('span', {
          attrs: {
            "title": "Shows the % of users who responded with the option numbers shown in the initial message"
          }
        }, [_c('i', {
          staticClass: "fa fa-info-circle margin-10"
        })])]) : _vm._e()]
      }
    }], null, true)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_c('nv-empty-state', {
    attrs: {
      "icon": "fa-bar-chart",
      "title": "No campaigns in this period",
      "hint": "Try a different date range."
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "loadingContent"
  })], 2)], 1)])])])])])])])]), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      Database Marketing Campaigns Report\n    ")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_vm._v("Campaigns")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Campaigns Report")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-8794fe36","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/opportunity-management/databaseMarketingReport.vue
// module id = e9jL
// module chunks = 1